/**
 * Normalizes a feed type string for name-lookup between InventoryItem and FeedLog.
 * Lowercases, strips diacritics + non-alphanumerics, so "10 mm" and "10mm" and
 * "10-MM" all match. Empty input → empty string (no match).
 *
 * Used by:
 * - Warehouse UI (Inventory.tsx) to match auto-suggested feed types from recent
 *   FeedLog history against InventoryItem `usageFeedType` / `name`.
 * - Auto-derivation (feedLogCostDerivation.ts) to resolve a FeedLog `feedType`
 *   to the paired InventoryItem for cost lookup.
 *
 * DO NOT change the algorithm without updating both call sites and adding
 * a migration for historical FeedLog metadata that carries pre-normalized keys.
 */
export const normalizeFeedTypeKey = (value: string): string => {
  const raw = value.trim().toLowerCase()
  if (!raw) return ''
  return raw
    .normalize('NFKD')
    .replaceAll(/\p{M}+/gu, '')
    .replaceAll(/[^\p{L}\p{N}]+/gu, '')
}
